"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _ConditionsRow = _interopRequireDefault(require("./ConditionsRow"));
var _index = require("../index");
var _cccisdFormik = require("cccisd-formik");
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Conditions = function Conditions(_ref) {
  var field = _ref.field,
    form = _ref.form;
  var _field$value = field.value,
    conditions = _field$value.conditions,
    nextKey = _field$value.nextKey;
  var conditionsCount = conditions.length;
  var addRow = function addRow() {
    form.setFieldValue('ifThen', _objectSpread(_objectSpread({}, field.value), {}, {
      conditions: [].concat(_toConsumableArray(conditions), [{
        key: nextKey,
        condition: _index.initialCondition
      }]),
      nextKey: nextKey + 1
    }));
  };
  var removeRow = function removeRow(index) {
    if (conditionsCount <= 1) return;
    var updated = _toConsumableArray(conditions);
    updated.splice(index, 1);
    form.setFieldValue('ifThen', _objectSpread(_objectSpread({}, field.value), {}, {
      conditions: updated
    }));
  };
  var moveUp = function moveUp(index) {
    if (conditionsCount <= 1 || index === 0) return;
    var updated = [];
    conditions.forEach(function (c, i) {
      if (i === index - 1) updated.push(conditions[index]);
      if (i !== index) updated.push(c);
    });
    form.setFieldValue('ifThen', _objectSpread(_objectSpread({}, field.value), {}, {
      conditions: updated
    }));
  };
  var moveDown = function moveDown(index) {
    if (conditionsCount <= 1 || conditionsCount === index + 1) return;
    var updated = [];
    conditions.forEach(function (c, i) {
      if (i !== index) updated.push(c);
      if (i === index + 1) updated.push(conditions[index]);
    });
    form.setFieldValue('ifThen', _objectSpread(_objectSpread({}, field.value), {}, {
      conditions: updated
    }));
  };
  var hr = /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react["default"].createElement("hr", null)));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6 text-right"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "If rule is true"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].rulesOrderText
  }, "Rules are evaluated in order they appear")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Then set formula value to"))), hr, conditions.map(function (condition, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: condition.key
    }, /*#__PURE__*/_react["default"].createElement(_ConditionsRow["default"], {
      index: index,
      conditionsCount: conditionsCount,
      removeRow: removeRow,
      moveUp: moveUp,
      moveDown: moveDown
    }), hr);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 text-right"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-secondary",
    onClick: addRow,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), " Add If Then Rule"))), hr, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6 text-right ".concat(_style["default"].otherwise)
  }, "Otherwise"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].value
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "ifThen.otherwise",
    component: _cccisdFormik.CccisdInput
  })))), hr);
};
Conditions.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object
};
var _default = exports["default"] = Conditions;